// google-maps-loader.service.ts
import { Injectable, Inject } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';
import { GOOGLE_MAPS_CONFIG, GoogleMapsConfig } from './google-maps-config';

@Injectable()
export class GoogleMapsLoaderService {
  private loader: Loader;

  constructor(@Inject(GOOGLE_MAPS_CONFIG) private config: GoogleMapsConfig) {
    this.loader = new Loader({
      apiKey: this.config.apiKey,
      libraries: this.config.libraries,
    });
  }

  getLoader(): Loader {
    return this.loader;
  }
}
